const LABELS = {
  DRAFT: "Draft",
  AWAITING_CLIENT: "Sent to client",
  CLIENT_SUBMITTED: "Client submitted",
  PARTNER_CONFIRMED: "Confirmed",
  SENT_TO_ORG: "With the office",
  ACTIVATED: "Active client",
  REJECTED: "Returned",
};

const TONES = {
  DRAFT: "default",
  AWAITING_CLIENT: "info",
  CLIENT_SUBMITTED: "warning",
  PARTNER_CONFIRMED: "info",
  SENT_TO_ORG: "info",
  ACTIVATED: "success",
  REJECTED: "error",
};

const NEXT_ACTIONS = {
  DRAFT: "Finish the details or send the client a link",
  AWAITING_CLIENT: "Waiting on the client",
  CLIENT_SUBMITTED: "Review and send to the office",
  PARTNER_CONFIRMED: "Send to the office",
  SENT_TO_ORG: "With the office",
  ACTIVATED: "Active client",
  REJECTED: "Returned, fix and resend",
};

const LOCKED_STATES = ["SENT_TO_ORG", "ACTIVATED"];

export const leadStateLabel = (state) => LABELS[state] || "Unknown";
export const leadStateTone = (state) => TONES[state] || "default";
export const nextActionFor = (lead) => NEXT_ACTIONS[lead?.state] || "";
export const canEditLead = (lead) => !LOCKED_STATES.includes(lead?.state);
export const canEmailClientLink = (lead) =>
  canEditLead(lead) && Boolean(String(lead?.email || "").trim());

/** The link is out with the client and nothing has come back, so the partner is vouching blind. */
export const isAwaitingClient = (lead) => lead?.state === "AWAITING_CLIENT";

/** One action, three jobs: review what came back, fill it in yourself, or read a sent lead. */
export const fullFormLabel = (lead) => {
  if (lead?.state === "CLIENT_SUBMITTED") return "Review";
  if (!canEditLead(lead)) return "View form";
  return "Full form";
};

export const canConfirmLead = (lead) =>
  canEditLead(lead) &&
  Boolean(String(lead?.name || "").trim()) &&
  Boolean(String(lead?.email || "").trim() || String(lead?.number || "").trim());

/** States where the next move is the partner's, so the row is flagged in the list. */
export const needsPartnerAction = (lead) =>
  ["CLIENT_SUBMITTED", "REJECTED", "PARTNER_CONFIRMED"].includes(lead?.state);

/**
 * The one button a lead row shows; everything else sits in its overflow menu.
 * A submitted form is reviewed before it is sent, so "review" wins over "send".
 */
export const primaryLeadAction = (lead) => {
  if (lead?.state === "CLIENT_SUBMITTED") return "review";
  if (!canEditLead(lead)) return "view";
  if (canConfirmLead(lead)) return "send";
  return "edit";
};
